import { ResponseArray, ResponseObject } from '@/types/shared'
import {
    EmployeeEvent,
    EventFormData,
    EventSummary,
    RoomAvailability,
} from '../types'
import datacentral from '@/utils/axios/datacentral'

export const createEvent = async (
    payload: Partial<EventFormData> & { start_date: string }
) => {
    console.log('🚀 createEvent service received payload:', payload)
    console.log('🚀 payload type:', typeof payload)
    console.log('🚀 payload keys:', Object.keys(payload))
    console.log('🚀 payload values:', Object.values(payload))

    const response = await datacentral.post<ResponseObject<Event>>(
        `/events`,
        payload
    )
    console.log('🚀 API response:', response.data)
    return response.data
}

export const getEventPopularByDate = async (date: string) => {
    const response = await datacentral.get<ResponseArray<EmployeeEvent>>(
        `/events/date/${date}`
    )
    return response.data
}

// summary / week /: date
export const getEventSummaryByWeek = async (date: string) => {
    const response = await datacentral.get<ResponseObject<EventSummary>>(
        `/events/summary/week/${date}`
    )
    return response.data
}

// get BookedTime
export const getRoomAvailable = async (date: string) => {
    const response = await datacentral.get<ResponseArray<RoomAvailability[]>>(
        `/events/rooms/availability?date=${date}`
    )
    return response.data
}
